module.exports = __webpack_public_path__ + "img/dollar.f097d1aa.svg";